import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertService } from '../alert/alert.service';
import { Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { LoginDialogComponent } from 'src/app/components/login/login-dialog.component';
import { SetCurrentUser } from 'src/app/store/actions';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class LoginDialogService {
  homeRoutes = ['/', '//', '/login'];
  constructor(
    private dialog: MatDialog,
    private alert: AlertService,
    private store: Store,
    private router: Router,
    private cookie: CookieService
  ) { }

  openDialog() {
    const dialogRef = this.dialog.open(LoginDialogComponent, {
      height: "32em",
      width: "25em",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response?.code == 423 || response?.code == 401) {
        response?.code === 423 ? this.alert.message('Login_UserInactive') : response?.code === 401 ? this.alert.message('Login_UserUndefined') : null;
      }
      else if (response?.token) {
        this.store.dispatch(new SetCurrentUser(response?.token));
        this.navigateOrRedirect();
      }
    });

  }

  login(redirectUrl?: string) {
    if (document.location.hostname === environment.productionEnvironment) {
      location.href = environment.mfaURL;
    } else {
      const currentUrl = redirectUrl ?? this.router.url; // this is the URL user is trying to access
      if (!this.homeRoutes.includes(currentUrl)) {
        this.navigateOrRedirect();
      }
      else this.openDialog();
    }
  }

  logout() {
    environment.token = '';
    this.cookie.delete('_shibobj', '/');
    localStorage.clear();
    this.store.dispatch(new SetCurrentUser(null));
    this.router.navigate(['/login']);
  }

  navigateOrRedirect() {
    const route = localStorage.getItem('redirect-route');
    if (route) this.router.navigate([route]);
    else this.router.navigate(['home']);
  }

}
